import React from 'react';
import { Toaster } from 'sonner';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { HoursSection } from './components/HoursSection';
import { PavilionMenu } from './components/PavilionMenu';
import { PopupLineup } from './components/PopupLineup';
import { Workshops } from './components/Workshops';
import { About } from './components/About';
import { MissionStrip } from './components/MissionStrip';
import { VendorSection } from './components/VendorSection';
import { PartnerSection } from './components/PartnerSection';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-foodCream selection:bg-foodOrange selection:text-white" data-id="element-0" data-mp="2wifgbev2vaz8">
      <Toaster position="bottom-right" toastOptions={{
      style: {
        background: '#F5EFE0',
        color: '#2A1B14',
        border: '2px solid #2A1B14',
        boxShadow: '4px 4px 0px 0px #2A1B14',
        borderRadius: '0',
        fontWeight: 'bold',
        fontFamily: '"Inter", sans-serif'
      }
    }} data-id="element-1" data-mp="28t4jg8gum0qd" />

      <Nav data-id="element-2" data-mp="3rdatypw7kqlt" />

      <main data-id="element-3" data-mp="3rcsw5otwe4bs">
        <Hero data-id="element-4" data-mp="3rd17vdeab3le" />
        <HoursSection data-id="element-5" data-mp="3relw6la09qat" />
        <PopupLineup data-id="element-6" data-mp="6hqffdy0fe4" />
        <PavilionMenu data-id="element-7" data-mp="4wx1t3d72hu" />
        <Marquee data-id="element-8" data-mp="56nfhsbnbo2" />
        <Workshops data-id="element-9" data-mp="7su7f7e1n58" />
        <About data-id="element-10" data-mp="2zld0l5ad579f" />
        <MissionStrip data-id="element-11" data-mp="2zlv6ktmtuzuj" />
        <VendorSection data-id="element-12" data-mp="2zmenq84nlk7i" />
        <PartnerSection data-id="element-13" data-mp="2zn6actg9w7ln" />
        <Newsletter data-id="element-14" data-mp="33morde4z3yj7" />
      </main>

      <Footer data-id="element-15" data-mp="33nq4rp9gox43" />
    </div>;
}